import { render, staticRenderFns } from "./RandomSlogan.vue?vue&type=template&id=1cfec4d1&"
import script from "./RandomSlogan.vue?vue&type=script&lang=js&"
export * from "./RandomSlogan.vue?vue&type=script&lang=js&"
import style0 from "./RandomSlogan.vue?vue&type=style&index=0&id=1cfec4d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports